import { Alert, Grid } from "@mui/material";
import { useContext, useEffect } from 'react';
import { useLoader } from "../../../../hooks/useLoader";
import { QueryStatus } from "../../../../types";
import { SistemaTipo } from "../../../../types/enum/enum";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import SeccionLCSLHPTIDatosOperacion from './components/SeccionLCSLHPTIDatosOperacion';
import { OperacionLCSLHPTI } from "./types/types";
import { useOperacionLCSLHPTI } from "./hooks/useOperacionLCSLHPTI";
import SeccionLCSLHPTITablaValores from "./components/SeccionLCSLHPTITablaValores";
import { OperacionLCSLHPTIFields } from "./types/fields";


interface SistemaLCSLHPTIContentProps {
  operacion: OperacionLCSLHPTI
}

const SistemaLCSLHPTIContent = ({ operacion }: SistemaLCSLHPTIContentProps) => {
  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionLCSLHPTIDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionLCSLHPTITablaValores operacion={operacion} codSistemaPrincipal={operacion[OperacionLCSLHPTIFields.CodPais]} />
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.LCSLHPTI}
            idOperacion={operacion.id}
          />
        </Grid>
      </Grid>
    </>
  )
}

function SistemaLCSLHPTI() {
  const { idOperacion } = useContext<ContextOperacionType>(ContextOperacion);
  const { status, operacion } = useOperacionLCSLHPTI(idOperacion);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status]);

  if (!operacion) {
    return null;
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaLCSLHPTIContent
      operacion={operacion}
    />
  )
}

export default SistemaLCSLHPTI;